export const SUPPORT_ASSISTANT_ROOT_ROUTE = '/support'

export const BOOKING_CONFIRMATION_PAGE_ROUTE = '/account/my-escapes/order'
